import React, { Component } from 'react';

/**
 * Matches the Atlaskit Button API used in StatelessDialog.
 */
class CustomButton extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const {
            appearance = 'default',
            id,
            onClick,
            type = 'button',
            isDisabled,
            form,
            children
        } = this.props;

        const appearanceClass = `custom-btn--${appearance}`;
        const disabledClass = isDisabled ? ' custom-btn--disabled' : '';

        return (
            <button
                className = { `custom-btn ${appearanceClass}${disabledClass}` }
                disabled = { isDisabled }
                form = { form }
                id = { id }
                onClick = { isDisabled ? undefined : onClick }
                type = { type }>
                {children}
            </button>
        );
    }
}

export default CustomButton;
